import React from "react";

export const DashboardManagementIcon = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.0585 6.29248C17.5251 4.48415 16.0168 2.97582 14.2085 2.44248C12.8335 2.04248 11.8835 2.07582 11.2251 2.56748C10.4335 3.15915 10.3418 4.22582 10.3418 4.98415V7.05915C10.3418 9.10915 11.2751 10.1508 13.1085 10.1508H15.5001C16.2501 10.1508 17.3251 10.0591 17.9168 9.26748C18.4251 8.61748 18.4668 7.66748 18.0585 6.29248Z"
            />
            <path
                d="M15.7575 11.633C15.5409 11.383 15.2242 11.2413 14.8992 11.2413H11.9158C10.4492 11.2413 9.25752 10.0496 9.25752 8.58297V5.59964C9.25752 5.27464 9.11585 4.95797 8.86585 4.7413C8.62418 4.52464 8.29085 4.42464 7.97418 4.4663C6.01585 4.7163 4.21585 5.7913 3.04085 7.40797C1.85752 9.03297 1.42418 11.0163 1.79918 12.9996C2.34085 15.8663 4.63252 18.158 7.50752 18.6996C7.96585 18.7913 8.42418 18.833 8.88252 18.833C10.3908 18.833 11.8492 18.3663 13.0908 17.458C14.7075 16.283 15.7825 14.483 16.0325 12.5246C16.0742 12.1996 15.9742 11.8746 15.7575 11.633Z"
            />
        </svg>
    );
}
